import React from 'react'
import TextareaAutosize from 'react-autosize-textarea';
import SendIcon from "../../assets/images/chat/send-fast.svg";
import SearchIcon from "../../assets/images/chat/search-icon.svg";

const texts = {
    search: 'Search by company or context (Burger King, pizza)',
    chat: 'Ask me anything...'
}

function Input(props) {
    const { value, handleChange, handleChatSubmit, conversationtUI, disabled, company } = props;
    if (!conversationtUI && !company) {
        return (
            <div className='action__wrapper'>
                {!value && <label className="action-label" style={{ textTransform: 'uppercase' }}>Select a Company to start interaction</label>}
                <div className='action search'>
                    <img className='search-icon' src={SearchIcon} alt="Search..." />
                    <input
                        className='form-input'
                        type="search"
                        placeholder={texts.search}
                        value={value}
                        onChange={(e) => handleChange(e.target.value)}
                    />
                </div>
            </div>
        )
    }
    return (
        <div className='action'>
            <TextareaAutosize
                placeholder={texts.chat}
                name='bot-input'
                value={value}
                minRows={1}
                maxRows={6}
                className='form-input'
                onChange={(e) => handleChange(e.target.value)}
                onKeyDownCapture={(e) => {
                    if (e.key === 'Enter' && !e.shiftKey) {
                        e.preventDefault();
                        if (!disabled) {
                            handleChatSubmit();
                        }
                    }
                }}
            />
            <button
                className={`send-btn cursor-pointer ${(disabled) ? "disabled" : ""}`}
                onClick={() => handleChatSubmit()}>
                <img src={SendIcon} height={"auto"} />
            </button>
        </div>
    )
}

export default Input